function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
/**
 * The idea behind Controller is to provide a way to pass multiple functions to an UI component in a single package.
 * We cannot simply pass on an UI handler instance, since those contain functions and properties we don't want to pass to a component.
 * Controller is a subset of UI handler's functions.
 */
export var Controller = /*#__PURE__*/_createClass(
/**
 * @param {Object|StateHandler} UIHandler UI handler (possibly extending StateHandler)
 * @param {string[]} functionNames An array of the function names the component requires access to
 */
function Controller(UIHandler, functionNames) {
  var _this = this;
  _classCallCheck(this, Controller);
  functionNames.forEach(function (key) {
    _this[key] = function () {
      return UIHandler[key].apply(UIHandler, arguments);
    };
  });
});
;